export const DEGREE_SAMPLES: Record<string, string> = {
  'amity-online': 'https://amityonlinemba.jaro.in/img/certificate.png',
  'amity-university': 'https://amityonlinemba.jaro.in/img/certificate.png',
  'bharati-vidyapeeth': 'https://bharatividyapeethonlinemba.jaro.in/img/certificate.png',
  'bharati-vidyapeeth-university': 'https://bharatividyapeethonlinemba.jaro.in/img/certificate.png',
  'sikkim-manipal-smu': 'https://www.onlinemanipal.com/wp-content/uploads/2022/11/MBA-scaled.png',
  'sikkim-manipal-university': 'https://www.onlinemanipal.com/wp-content/uploads/2022/11/MBA-scaled.png',
  'manipal-online': 'https://www.onlinemanipal.com/wp-content/uploads/2022/11/MBA-scaled.png',
  'manipal-jaipur': 'https://www.onlinemanipal.com/wp-content/uploads/2022/11/MBA-scaled.png',
  'dy-patil-online-pune': 'https://www.dypatilonline.com/onlinemba/admissions/images/certificates.webp',
  'dy-patil-pune': 'https://www.dypatilonline.com/onlinemba/admissions/images/certificates.webp',
  'nmims-online': 'https://s3.ap-south-1.amazonaws.com/online.nmims.edu-v3/uploads/media/2026/2/23/media_1771847013215.jpg',
  nmims: 'https://s3.ap-south-1.amazonaws.com/online.nmims.edu-v3/uploads/media/2026/2/23/media_1771847013215.jpg',
};
